<template>
  <div>
    <page-header :title="title" />
    <page-body needMarginBottom>
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
        <!-- 告警内容 -->
        <h2>{{$t('bill.alarm_content')}}</h2>
        <a-form-model-item class="mb-0" :label="$t('bill.billing_config')">
          <span>{{$t('scope.text_442')}}: </span><span>{{ currencyText }}</span>
          <span class="ml-3">{{$t('bill.bill_prepaid_amortizing')}}: </span><span>{{ rowData.is_prepaid_amortizing || formData.is_prepaid_amortizing ? $t('table.title.on') : $t('table.title.off') }}</span>
          <span class="ml-3">{{$t('bill.bill_project_sharing')}}: </span><span>{{ rowData.is_project_sharing || formData.is_project_sharing ? $t('table.title.on') : $t('table.title.off') }}</span>
        </a-form-model-item>
        <a-form-model-item class="mb-0" :label="$t('monitor.text00015')">
          <div class="d-flex">
            <span>{{$t('common.text00118')}}: </span><span class="ml-2">{{ scopeText }}</span>
            <span class="ml-3">{{$t('common_547', [$t('dictionary.domain')])}}: </span>
            <base-select
              v-if="isAdminMode && l3PermissionEnable"
              v-model="form.domain_id"
              :filterable="true"
              resource="domains"
              version="v1"
              :params="{ limit: 20 }"
              :selectStyle="{maxWidth: '165px', 'margin-left': '10px'}"
              isDefaultSelect />
            <span v-else class="ml-2">{{ rowData.project_domain || userInfo.projectDomain }}</span>
            <span class="ml-3">{{$t('common_547', [$t('dictionary.project')])}}: </span>
            <base-select
              v-if="isAdminMode || isDomainMode"
              v-model="form.project_id"
              :filterable="true"
              resource="projects"
              version="v1"
              :params="projectParams"
              :selectStyle="{maxWidth: '165px', 'margin-left': '10px'}"
              isDefaultSelect>
              <template #optionTemplate="{ options }">
                <a-select-option v-for="item of options" :key="item.id" :value="item.id" :label="item.name">
                  {{ item.name }}
                </a-select-option>
              </template>
            </base-select>
            <span v-else class="ml-2">{{ rowData.tenant || userInfo.projectName }}</span>
          </div>
        </a-form-model-item>
        <a-form-model-item class="mb-0" :label="$t('monitor.text_101')">
          <template v-if="filterList.length">
            <span v-for="(item, index) in filterList" :key="index" :class="{'ml-3': index > 0}">{{ item.label }}</span>
          </template>
          <template v-else>
            <span>-</span>
          </template>
        </a-form-model-item>
        <a-form-model-item class="mb-0" :label="$t('bill.alarm_dimension')">
          <template v-if="groupList.length">
            <span v-for="(item, index) in groupList" :key="index" :class="{'ml-3': index > 0}">{{ item.label }}</span>
          </template>
          <template v-else>
            <span>-</span>
          </template>
        </a-form-model-item>
        <!-- 告警设置 -->
        <h2>{{$t('bill.alarm_setting')}}</h2>
        <a-form-model-item :label="$t('bill.text_88')" prop="name">
          <a-input v-model="form.name" />
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.text_198')" prop="time_range">
          <a-radio-group v-model="form.time_range" :options="timeRangeOptions" :disabled="formType === 'update'" />
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.budget_alert_threshold')" prop="threshold">
          <div class="d-flex">
            <a-form-model-item class="mb-0">
              <a-radio-group v-model="form.threshold_type" :options="thresholdTypeOptions" :disabled="formType === 'update'" />
            </a-form-model-item>
            <a-form-model-item prop="threshold" class="mb-0">
              <span class="mr-2">{{$t('bill.text_205')}}:</span>
              <span class="mr-2" v-if="form.threshold_type === 'absolute'">{{currencySign}}</span>
              <a-input-number v-model="form.threshold" style="width: 100px;" />
              <span class="ml-2" v-if="form.threshold_type === 'relative'">%</span>
            </a-form-model-item>
          </div>
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.trend')" prop="trend">
          <a-radio-group v-model="form.trend" :options="trendOptions" />
        </a-form-model-item>
        <cost-alarm-table :form="form" :queryParams="formData" :groupList="groupList" :currencySign="currencySign" />
        <!-- 告警通知 -->
        <h2>{{$t('bill.alarm_notice')}}</h2>
        <a-form-model-item :label="$t('common.notify_type')" prop="notify_type">
          <a-checkbox-group
            v-model="form.notify_type">
            <a-checkbox
              v-for="v in notifyTypeOptions"
              :key="v.value"
              :value="v.value">
              {{ v.label }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.notify_type.includes('receiver')" :label="$t('bill.budget_alert_user')" prop="recipients">
          <a-spin v-show="!recipientsLoaded" />
          <base-select
            v-show="recipientsLoaded"
            v-model="form.recipients"
            optionLabelProp="label"
            class="w-100"
            :filterable="true"
            needParams
            resource="receivers"
            version="v1"
            @change="contactArrOptsChange"
            :params="recipientParams"
            :resList.sync="recipientOpts"
            :initLoaded.sync="recipientsLoaded"
            :select-props="{ placeholder: $t('bill.budget_alert_user_placeholder'), allowClear: true, mode: 'multiple' }" />
        </a-form-model-item>
        <a-form-model-item v-if="form.notify_type.includes('receiver')" :label="$t('common_599')" prop="channel">
          <a-checkbox-group
            v-model="form.channel">
            <a-checkbox
              v-for="v in contactArrOpts"
              :key="v.label"
              :value="v.value"
              :disabled="v.disabled">
              <template v-if="v.disabled">
                <a-tooltip placement="top">
                  <template slot="title">
                    {{$t('monitor.commonalerts.channel.disable.tips', [v.label])}}
                  </template>
                  {{ v.label }}
                </a-tooltip>
              </template>
              <template v-else>
                {{ v.label }}
              </template>
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.notify_type.includes('role')" :label="$t('dictionary.role')" prop="roles">
          <base-select
            v-model="form.roles"
            class="w-100"
            :filterable="true"
            resource="roles"
            version="v1"
            :select-props="{ allowClear: true, mode: 'multiple' }" />
        </a-form-model-item>
        <a-form-model-item v-if="form.notify_type.includes('robot')" :label="$t('monitor.text_11')" prop="robots">
          <base-select
            v-model="form.robots"
            class="w-100"
            :filterable="true"
            resource="robots"
            version="v1"
            :select-props="{ placeholder: $t('common.tips.select', [$t('monitor.text_11')]), allowClear: true, mode: 'multiple' }" />
        </a-form-model-item>
      </a-form-model>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button class="mr-3" type="primary" @click="handleConfirm" :loading="loading">{{$t('compute.text_907')}}</a-button>
        <a-button @click="handleCancel">{{$t('compute.text_908')}}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import { validateModelForm } from '@/utils/validate'
import { currencyUnitMap } from '@/constants/currency'
import { getCurrencyOptions } from '@Bill/utils'
import { getGroupList, getFilterList } from './utils'
import CostAlarmTable from './components/CostAlarmTable.vue'

export default {
  name: 'AnalysisAlarmCreate',
  components: {
    CostAlarmTable,
  },
  data () {
    return {
      formItemLayout: {
        wrapperCol: {
          md: { span: 18 },
          xl: { span: 20 },
          xxl: { span: 22 },
        },
        labelCol: {
          md: { span: 6 },
          xl: { span: 4 },
          xxl: { span: 2 },
        },
      },
      formType: 'create',
      formData: {},
      rowData: {},
      form: {
        name: '',
        domain_id: undefined,
        project_id: undefined,
        time_range: 'DOD PC',
        threshold_type: 'absolute',
        threshold: undefined,
        trend: 'ASC',
        notify_type: [],
        channel: ['webconsole'],
        robots: [],
        recipients: [],
        roles: [],
      },
      rules: {
        name: [
          { required: true, message: this.$t('common.tips.input', [this.$t('bill.text_88')]) },
        ],
        threshold: [
          { required: true, message: this.$t('common.tips.input', [this.$t('bill.budget_alert_threshold')]) },
        ],
        time_range: [
          { required: true, message: this.$t('common.tips.select', ['']) },
        ],
        trend: [
          { required: true, message: this.$t('common.tips.select', ['']) },
        ],
      },
      // 日同比: DOD PC 日环比: DoD 月同比: MoM PC 月环比: MoM
      timeRangeOptions: [
        { value: 'DOD PC', label: `${this.$t('bill.daily_cost_alarm')} (${this.$t('bill.dod_pc_tip')})` },
        { value: 'DoD', label: `${this.$t('bill.daily_cost_alarm')} (${this.$t('bill.dod_tip')})` },
        { value: 'MOM PC', label: `${this.$t('bill.monthly_cost_alarm')} (${this.$t('bill.mom_pc_tip')})` },
        { value: 'MoM', label: `${this.$t('bill.monthly_cost_alarm')} (${this.$t('bill.mom_tip')})` },
      ],
      thresholdTypeOptions: [
        { value: 'absolute', label: this.$t('bill.absolute') },
        { value: 'relative', label: this.$t('bill.relative') },
      ],
      trendOptions: [
        { value: 'ASC', label: this.$t('bill.trend_asc') },
        { value: 'DESC', label: this.$t('bill.trend_desc') },
        { value: 'ALL', label: this.$t('bill.trend_all') },
      ],
      notifyTypeOptions: [
        { value: 'receiver', label: this.$t('bill.budget_alert_user') },
        { value: 'role', label: this.$t('dictionary.role') },
        { value: 'robot', label: this.$t('monitor.text_11') },
      ],
      recipientsLoaded: false, // 报警接收人是否加载完成
      contactArrOpts: [],
      recipientOpts: [],
    }
  },
  computed: {
    ...mapState('common', {
      currency: state => state.bill.currency,
      currencyOpts: state => state.bill.currencyOpts || [],
    }),
    ...mapGetters(['isAdminMode', 'scope', 'isDomainMode', 'l3PermissionEnable', 'userInfo']),
    title () {
      if (this.formType === 'clone') {
        return this.$t('bill.analysis_cost_alarm_clone')
      }
      if (this.formType === 'update') {
        return this.$t('bill.analysis_cost_alarm_update')
      }
      return this.$t('bill.analysis_cost_alarm_create')
    },
    currentCurrency () {
      return this.formData.query_attributes?.origin_currency || this.rowData.currency || this.currency
    },
    currencyOptions () {
      return getCurrencyOptions()
    },
    currencySign () {
      if (currencyUnitMap[this.currentCurrency]) {
        return currencyUnitMap[this.currentCurrency].sign || ''
      }
      return ''
    },
    currencyText () {
      const target = this.currencyOptions.filter(item => item.item_id === this.currentCurrency)
      if (target.length) {
        return target[0].item_name
      }
      return '-'
    },
    scopeText () {
      if (this.rowData.view_scope === 'system') {
        return this.$t('bill.system_view')
      }
      if (this.rowData.view_scope === 'domain') {
        return this.$t('bill.domain_view')
      }
      if (this.rowData.view_scope === 'project') {
        return this.$t('bill.project_view')
      }
      if (this.isAdminMode) {
        return this.$t('bill.system_view')
      }
      if (this.isDomainMode) {
        return this.$t('bill.domain_view')
      }
      return this.$t('bill.project_view')
    },
    filterList () {
      return getFilterList(this.formData)
    },
    groupList () {
      return getGroupList(this.formData)
    },
    recipientParams () {
      return {
        is_system_account: false,
        scope: this.scope,
        project_domain_filter: this.isDomainMode,
      }
    },
    projectParams () {
      const ret = { limit: 20 }
      if (this.form.domain_id) {
        ret.domain_id = this.form.domain_id
      }
      return ret
    },
  },
  created () {
    this.init()
  },
  methods: {
    thresholdFormatter (value) {
      return this.form.threshold_type === 'absolute' ? `${this.currencySign} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : `${value} %`
    },
    thresholdParser (value) {
      return this.form.threshold_type === 'absolute' ? value.replace(this.currencySign, '').replace(' ', '').replace(/\$\s?|(,*)/g, '') : value.replace(' %', '')
    },
    init () {
      const { type, row, data } = this.$route.params
      if (type === 'clone' || type === 'update') {
        this.formData = row.query_attributes || {}
        this.formType = type
        this.rowData = row
        this.form.name = row.name
        this.form.time_range = row.time_range
        if (row.alarm_abs_threshold) {
          this.form.threshold_type = 'absolute'
          this.form.threshold = row.alarm_abs_threshold
        } else {
          this.form.threshold_type = 'relative'
          this.form.threshold = row.alarm_rel_threshold
        }
        this.form.trend = row.trend
        this.form.domain_id = row.domain_id
        this.form.project_id = row.tenant_id
        const notify_type = []
        if (row.user_ids) {
          notify_type.push('receiver')
        }
        if (row.role_ids) {
          notify_type.push('role')
        }
        if (row.robot_ids) {
          notify_type.push('robot')
        }
        this.form.notify_type = notify_type
        this.form.recipients = row.user_ids || []
        this.form.roles = row.role_ids || []
        this.form.robots = row.robot_ids || []
      } else {
        this.formData = data || {}
        this.rowData = {}
        this.form.domain_id = this.userInfo.projectDomainId
        this.form.project_id = this.userInfo.projectId
      }
    },
    contactArrOptsChange (rs) {
      const getLabel = (val) => {
        if (val === 'mobile') val = 'message' // mobile 应该翻译为 短信
        if (this.$t(`common.${val}`)) {
          return this.$t(`common.${val}`)
        }
        return val
      }
      if (rs) {
        const ect = this.recipientOpts.filter((opt) => {
          return rs.indexOf(opt.id) >= 0
        }).map((opt) => {
          return opt.enabled_contact_types
        })
        this.contactArrOpts = _.intersection(...ect).map((c) => {
          return {
            value: c,
            label: getLabel(c),
            disabled: c === 'webconsole',
          }
        })
      }
    },
    genParams () {
      const params = {
        name: this.form.name,
        domain_id: this.form.domain_id,
        project_id: this.form.project_id,
        currency: this.currency.replace('*', '').replace('_', ''),
        alarm_groups: this.formData.group,
        time_range: this.form.time_range,
        is_prepaid_amortizing: this.form.is_prepaid_amortizing,
        is_project_sharing: this.form.is_project_sharing,
        trend: this.form.trend,
      }
      if (this.form.threshold_type === 'absolute') {
        params.alarm_abs_threshold = this.form.threshold
      } else {
        params.alarm_rel_threshold = this.form.threshold
      }
      if (this.isAdminMode) {
        params.view_scope = 'system'
      } else if (this.isDomainMode) {
        params.view_scope = 'domain'
      } else {
        params.view_scope = 'project'
      }
      if (this.form.notify_type.includes('receiver')) {
        params.user_ids = this.form.recipients
      } else if (this.form.notify_type.includes('role')) {
        params.role_ids = this.form.roles
      } else if (this.form.notify_type.includes('robot')) {
        params.robot_ids = this.form.robots
      }
      const attrs = { ...this.formData, origin_currency: this.currency }
      delete attrs.groups
      params.query_attributes = attrs
      return params
    },
    async handleConfirm () {
      await validateModelForm(this.$refs.form)
      const params = this.genParams()
      if (this.formType === 'update') {
        await new this.$Manager('bill_analysis_alarms', 'v1').update({
          id: this.rowData.id,
          data: params,
        })
      } else {
        await new this.$Manager('bill_analysis_alarms', 'v1').create({
          data: params,
        })
      }
      this.$router.push({
        name: 'BillAnalysisAlarm',
      })
    },
    handleCancel () {
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
h2 {
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.item-label {
  font-weight: bold;
  width: 150px;
  display: inline-block;
}
</style>
